import { useNavigate } from 'react-router-dom';
import OnboardingForm from '../../components/participant/OnboardingForm';
import { BrCard } from '@govbr-ds/react-components';

export default function ParticipantOnboardingPage() {
    const navigate = useNavigate();

    const handleComplete = () => {
        navigate('/participante/instrucoes');
    };

    return (
        <div className="container-lg py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8">
                    <BrCard>
                        {/* Header */}
                        <div className="text-center mb-8">
                            <div className="w-16 h-16 bg-primary-default rounded-2xl mx-auto mb-4 d-flex align-items-center justify-content-center">
                                <span className="text-3xl text-pure-0">👋</span>
                            </div>
                            <h1 className="text-2xl font-bold text-gray-80">
                                Bem-vindo à Pesquisa
                            </h1>
                            <p className="text-gray-60 mt-3">
                                Você está participando de uma pesquisa sobre interfaces de consulta processual.
                                Suas respostas nos ajudarão a criar sistemas mais fáceis de usar.
                            </p>
                        </div>

                        {/* Info box */}
                        <div className="bg-info border-l-4 border-info p-4 rounded-r-lg mb-8" style={{ backgroundColor: 'rgba(19, 81, 180, 0.1)' }}>
                            <div className="d-flex align-items-start gap-3">
                                <span className="text-xl">⏱️</span>
                                <div>
                                    <p className="font-semibold text-gray-80">Tempo estimado: 10-15 minutos</p>
                                    <p className="text-sm text-gray-60 mt-1">
                                        Você poderá pausar e continuar a qualquer momento.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Form */}
                        <OnboardingForm onComplete={handleComplete} />
                    </BrCard>

                    {/* Privacy notice */}
                    <p className="text-center text-sm text-gray-40 mt-4">
                        🔒 Suas respostas são anônimas e serão utilizadas apenas para fins de pesquisa acadêmica.
                    </p>
                </div>
            </div>
        </div>
    );
}
